import Switch from 'components/shared/Switch/Switch';

export const popoverOptionsContextMenu = ({
  filters,
  setFilters = () => {},
  setLoadMacrosModal = () => {},
  setCreateMacroModal = () => {},
  setShowPrevNoteModal = () => {},
  showLock = false,
  showExport = false,
  showAutoSave = false,
  noteLocked = false,
  handleRunPreviewNote = () => {},
  autosave,
  setShowClearNoteConfirmModal = () => {},
  handleAutoSave = () => {},
  userSign = false,
  onShowConfirmSignLock = () => {},
  saveButtonText = '',
  userAssignedToDocument = {},
  clinicalNoteId,
  showMyScribeAi = false,
  navigate = () => {},
  params = {},
  showTP = false,
  setShowTPModal = () => {},
  enabledTp = false,
  myscribeAIPath = false
}) => {
  const cnDisabled = saveButtonText === 'Saving' || !clinicalNoteId;
  return [
    {
      position: 'left',
      disabled: noteLocked,
      children: [
        {
          label: 'Load from appointment macros',
          icon: 'file-download-mono',
          onClick: () => {
            setFilters({ ...filters, macroType: 'appointment_macro' });
            setLoadMacrosModal(true);
          },
          'data-qa': 'load-from-appointments-templates'
        },
        {
          label: 'Save as new appointment macro',
          icon: 'save-mono',
          onClick: () => setCreateMacroModal(true),
          'data-qa': 'create-new-appointment-template'
        }
      ],
      icon: 'note-mono',
      label: 'Appointment macros',
      'data-qa': 'appointment-templates'
    },
    {
      position: 'left',
      disabled: noteLocked,
      children: [
        {
          label: 'Load from previous notes',
          icon: 'file-download-mono',
          onClick: () => setShowPrevNoteModal(true),
          'data-qa': 'load-from-previous-notes'
        }
      ],
      icon: 'history-linear',
      label: 'Previous notes',
      'data-qa': 'previous-notes'
    },
    showTP &&
      enabledTp && {
        icon: 'task-1-linear',
        disabled: noteLocked || cnDisabled,
        label: 'Treatmment Plan',
        onClick: () => setShowTPModal(true),
        'data-qa': 'treatment-plan'
      },
    showLock && {
      icon: userSign ? 'lock-2-opened-mono' : 'lock-2-mono',
      disabled: saveButtonText === 'Saving' || !clinicalNoteId || !userAssignedToDocument?.id,
      label: userSign ? 'Unlock' : 'Sign & Lock',
      onClick: (...r) => {
        onShowConfirmSignLock(...r);
      },
      'data-qa': 'lock'
    },
    showAutoSave && {
      disabled: noteLocked || cnDisabled,
      icon: (
        <Switch
          onChange={handleAutoSave}
          checked={autosave}
          name="Auto-save"
          color="neutral"
          onColor="#B0EAFF"
          onHandleColor="#13B9FF"
          offColor="#ECEFF0"
          offHandleColor="#8FA0A7"
          dataQa="auto-save-btn"
          disabled={noteLocked}
        />
      ),
      label: 'Auto save',
      'data-qa': 'auto-save'
    },
    showExport && {
      icon: 'export-mono',
      disabled: noteLocked || cnDisabled,
      label: 'Export',
      onClick: handleRunPreviewNote,
      'data-qa': 'export'
    },
    showMyScribeAi &&
      !myscribeAIPath && {
        icon: 'myscribeai-filled',
        label: (
          <div className="flex items-center">
            <span> Go to MyScribe AI (Beta) </span>
          </div>
        ),
        children: [
          {
            label: 'Chat-Style Charting',
            icon: 'message-charting-mono',
            onClick: () => {
              navigate(
                `/portal/charts/${params?.id}/clinical-notes/${params?.appointmentId}/myscribe-ai/automap`
              );
            },
            'data-qa': 'chat-style-charting'
          },
          {
            label: 'Ambient Listening (Coming soon)',
            icon: 'ambient-listening',
            disabled: true,
            onClick: () => setCreateMacroModal(true),
            'data-qa': 'ambient-listening'
          },
          {
            label: 'Enhance Note (Coming soon)',
            icon: 'enhance-current-note',
            disabled: true,
            onClick: () => setShowPrevNoteModal(true),
            'data-qa': 'enhance-current-note'
          }
        ],
        onClick: handleRunPreviewNote,
        'data-qa': 'export'
      },
    {
      icon: 'refresh-linear',
      disabled: noteLocked,
      label: 'Clear note',
      onClick: () => setShowClearNoteConfirmModal(true),
      'data-qa': 'clear-note'
    }
  ].filter(Boolean);
};
